module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_vm._v("© 2017 Johns Hopkins University Press")])]), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_c('p', {
    staticClass: "copy"
  }, [_vm._v("All rights reserved. Published 2017")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Printed in the United States of America on acid-free paper")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("2 4 6 8 9 7 5 3 1")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Johns Hopkins University Press")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("2715 North Charles Street")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Baltimore, Maryland 21218-4363")])]), _c('p', {
    staticClass: "copy"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.press.jhu.edu",
      "target": "_blank"
    }
  }, [_vm._v("www.press.jhu.edu")])]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Names: Merritt, Jane T., author.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Title: The trouble with tea : the politics of consumption in the eighteenth-century global economy / Jane T. Merritt.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Description: Baltimore : Johns Hopkins University Press, 2017. | Series: Studies in early American economy and society from the Library Company of Philadelphia | Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Identifiers: LCCN 2016012792| ISBN 9781421421520 (hardcover : alk. paper) |")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("ISBN 9781421421544 (pbk. : alk. paper) | ISBN 9781421421544 (electronic) |")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("ISBN 1421421526 (hardcover : alk. paper) | ISBN 1421421534 (pbk. : alk. paper) | ISBN 1421421542 (electronic)")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Subjects: LCSH: Tea trade—Political aspects—History—18th century | Great Britain—Commerce—History. | United States—Commerce—History. | United States—Foreign economic relations. | Great Britain—Foreign economic relations. | United States—Economic conditions—To 1865.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Classification: LCC HD9198.A2 M47 2017 | DDC 339.4/8663940941—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("LC record available at "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "https://lccn.loc.gov/2016012792",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2016012792")])]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("A catalog record for this book is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_c('em', [_vm._v("Special discounts are available for bulk purchases of this book. For more information, please contact Special Sales at 410-516-6936 or specialsales@press.jhu.edu.")])]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Johns Hopkins University Press uses environmentally friendly book materials, including recycled text paper that is composed of at least 30 percent post-consumer waste, whenever possible.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fad2c05a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copy.vue
// module id = 69
// module chunks = 0